import simpleFilename from './simple-filename';

export default function simpleAltFilename(filename) {
	let simple = simpleFilename(filename);
	return simple.split(/[/\\]/g).pop() || simple;
}